import { useEffect } from 'react';

export const HealthCheckView = () => {
  useEffect(() => {
    console.info(
      '[HealthCheck] Frontend configuration:',
      {
        VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL as string,
      }
    );
  }, []);

  return <div className='health-check-view'>
    <p>If you see this message, the frontend is running correctly. </p>
    <p>Custom fonts loading: {document.fonts.check('16px "Nunito Sans"') ? <span className='success'>✓ Success</span> : <span className='failed'>✗ Failed</span>}</p>
    <p>Web crypto API: {window.crypto?.subtle ? <span className='success'>✓ Success</span> : <span className='failed'>✗ Failed</span>}</p>
  </div>;
};
